<template>
  <div class="common-list">
    <el-card>
      <z-search ref="search" v-model="searchData" :configs="searchConfigs" :init="getCustomerList" @do-query="query" />
    </el-card>
    <el-card class="mt10">
      <div class="mb-16">
        <!-- <el-button type="primary" icon="el-icon-plus" @click="editRowFunc({})" v-auth="'customer::customer-list::add'">
          {{ $t('customer::customer-list::add_customer') }}
        </el-button>
        <el-button @click="markTag" v-auth="'customer::customer-list::tag'">
          {{ $t('customer::customer-list::batch_tag') }}
        </el-button> -->
        <el-button type="" @click="tagVisible = true">{{ $t('customer::customer-list::标签规则') }}</el-button>
      </div>
      <z-table
        v-loading="loading"
        :data="lists"
        :columns="columns"
        auto-calc-table-height
        :pagination.sync="pagination"
        :max-height="550"
        @page-change="handlePageChange"
        @selection-change="selectionChange"
      >
        <template #userEmail="{ row }">
          <div>{{ row.userEmail }}</div>
          <div v-if="row.userType">
            <el-tag size="mini" style="margin-right: 4px">
              {{ row.userType }}
            </el-tag>
            <!-- <el-dropdown v-if="row.customerTags.length > 1">
              <el-tag size="mini" style="margin-right: 2px">...</el-tag>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in row.customerTags" :key="index">
                  <el-tag size="medium">{{ item.tagName }}</el-tag>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </div>
        </template>
        <template #phone="{ row }">
          {{ $dataCheck(row.phone) }}
        </template>
        <template #customerLevelName="{ row }">
          {{ $dataCheck(row.customerLevelName) }}
        </template>
        <template #ordersCount="{ row }">
          {{ $dataCheck(row.ordersCount, '0') }}
        </template>
        <template #totalSpent="{ row }">
          {{ $dataCheck(row.totalSpent, '0') }}
        </template>
        <template #refundOrderCount="{ row }">
          {{ $dataCheck(row.refundOrderCount, '0') }}
        </template>
        <template #acceptsMarketing="{ row }">
          {{ row.acceptsMarketing === 1 ? editText.has_subscribe : editText.no_subscribe }}
        </template>
        <template #operate="{ row }">
          <!-- <el-button type="text" @click="editRowFunc(row)" v-auth="'customer::customer-list::edit'">
            {{ editText.edit }}
          </el-button> -->
          <el-button type="text" @click="toDetail(row)" v-auth="'customer::customer-list::customer-detail'">
            {{ editText.detail }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <edit-dialog v-model="visiable" :row="editRow" @submit="getCustomerList"></edit-dialog>
    <Marking v-model="markVisiable" :selectList="selectList" :tagList="tagList" @getData="getCustomerList"></Marking>
    <TagRule v-model="tagVisible"></TagRule>
  </div>
</template>
<script>
import { SEARCH_CONFIGS, CUSTOMER_COLUMNS } from '../config'
// import { getCustomerList } from '@/server/customers'
import { getCustomerList } from '@/server/etl'
import EditDialog from '@/views/customer/components/editDialog'
import Marking from '@/views/customer/components/marking'
import TagRule from '@/views/customer/components/tagRule'
import { getDicByCode } from '@/server/common'
export default {
  name: 'CustomerList',
  components: { EditDialog, Marking, TagRule },
  data() {
    return {
      editText: {
        has_subscribe: this.$t('customer::customer-list::has_subscribe'),
        no_subscribe: this.$t('customer::customer-list::no_subscribe'),
        edit: this.$t('customer::customer-list::edit'),
        detail: this.$t('customer::customer-list::detail'),
      },
      searchConfigs: SEARCH_CONFIGS,
      columns: CUSTOMER_COLUMNS,
      lists: [],
      loading: false,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      searchData: {
        filterObj: 'userEmail',
        target: '',
      },
      visiable: false,
      selectList: [],
      editRow: {},
      markVisiable: false,
      levelList: [],
      tagList: [],
      tagVisible: false,
    }
  },
  async created() {
    // const [tag, level] = await Promise.all([getDicByCode(8), getDicByCode(9)])
    // if (tag.data.code === this.$code) {
    //   this.tagList = tag.data.data
    //   this.searchConfigs[2].componentData.options = tag.data.data.map(item => ({
    //     label: item.name,
    //     value: item.id
    //   }))
    // }
    // if (level.data.code === this.$code) {
    //   this.levelList = level.data.data
    //   this.searchConfigs[1].componentData.options = level.data.data.map(item => ({
    //     label: item.name,
    //     value: item.id
    //   }))
    // }
  },
  methods: {
    toDetail(row) {
      if (!row.userEmail) return
      this.$router.push(`/customer/detail/${row.userEmail}`)
    },
    markTag() {
      if (this.selectList.length === 0) return this.$message.warning(this.$t('customer::customer-list::at_least_one'))
      this.markVisiable = true
    },
    async getCustomerList(searchData = this.searchData) {
      const params = {
        ...this.pagination,
        ...searchData,
        orgUnitId: this.$store.state.user.merchantId,
      }
      if (params.target) params.target = params.target.replace(/\s+/g, '')
      delete params.total
      delete params.filterObj
      delete params.target
      this.loading = true
      const { data } = await getCustomerList(params)
      if (data.code === this.$code) {
        this.lists = data.data.datas
        this.pagination.total = data.data.totalSize
      }
      this.loading = false
    },
    handlePageChange() {
      this.getCustomerList()
    },
    query(params) {
      this.pagination.pageNum = 1
      this.getCustomerList(params)
    },
    selectionChange(value) {
      this.selectList = value
    },
    editRowFunc(row) {
      this.editRow = row
      this.visiable = true
    },
  },
}
</script>
